export default __webpack_public_path__ + "static/media/Eddie.659495f9.png";